export default __webpack_public_path__ + "static/media/1.230115fd.jpg";